import React from 'react'

const LeaveBalance = () => {
  return (
    <div>LeaveBalance</div>
  )
}

export default LeaveBalance